export default "<db:successrate>\n\t<span data-id='value' class='pct'>P(S)</span>\n</db:successrate>";